export const environment = {
  production: false,
  siteUrl: "https://dev.stepintosrilanka.travel",
  contactEmail: "tours@stepintosrilanka.travel",
  contactPhone: "+94 76 733 1600",
  contactPhoneHref: "0767331600",
  whatsappNumber: "94767331600",
  // Firebase Web App "Step Into Sri Lanka - Dev" — its own GA4 data stream,
  // separate from prod. apiKey/authDomain/projectId are not secrets; Firebase
  // security is enforced by Security Rules and API key HTTP-referrer
  // restrictions, not by hiding this config.
  firebase: {
    apiKey: "AIzaSyAlp4WLd2pg2Rc_fotGajHocvGyGKwVYeg",
    authDomain: "step-into-sri-lanka.firebaseapp.com",
    projectId: "step-into-sri-lanka",
    storageBucket: "step-into-sri-lanka.firebasestorage.app",
    messagingSenderId: "554440979024",
    appId: "1:554440979024:web:1cd387b2bc9695756a1755",
    measurementId: "G-BCQ4ZB8W2P",
  },
};
